import { Input, Radio, Space } from "antd";
import React, { useRef } from "react";
import ImageDisplay from "../ImageDisplay/ImageDisplay";

export function SingleChoiceItem (props){
    const {item, index, current, pageSize} = props;
    const {question, options, correctAnswer, reason, isMore, url} = item;
    return (
        <>
            <p style={{fontWeight: 'bold', fontSize: '14px'}}>
                {(current-1) * pageSize + props.index + 1} : {question}
            </p>

            <Radio.Group value={correctAnswer} style={{width: '100%', }} disabled={true}>
                {/* <Space direction="horizontal" style={{width: '100%', }}> */}
                    {options.map((ele, key)=>
                        <Radio key={key} value={key} style={{width: '100%', 
                        // border: getAnswerOptionBorderStyle(ele, key),
                        borderRadius: '5px', padding: '10px'}}>
                            {ele}
                        </Radio>)}
                {/* </Space> */}
            </Radio.Group>
            <ImageDisplay imgList={url}/>
            {isMore && 
                <p style={{fontSize: '14px', paddingTop: '5px'}}>Explaination: {reason}</p>
            }
        </>
    );
}


export function EditSingleChoiceItem(props){
    const {item, index} = props;
    const {question, options, correctAnswer, reason, url, question_id, page, document_id} = item;
    const temOptionsRef = useRef(options.slice());
    
    const onChange = ({target: {value}})=>{
        props.handleAnswerChange({correctAnswer: value});
    }
    const handleTextChange = ({target: {value}}, index)=>{
        temOptionsRef.current[index] = value;
        props.handleAnswerChange({options: temOptionsRef.current});
    }
    const handleQuestionChange = ({target: {value}})=>{
        props.handleAnswerChange({question: value});
    }

    return (
        <>
            <Input defaultValue={question} onChange={handleQuestionChange}/>
            <Radio.Group defaultValue={correctAnswer} style={{width: '100%', }} onChange={onChange}>
                {/* <Space direction="horizontal" style={{width: '100%', }}> */}
                    {options.map((ele, key)=>
                        <Radio key={key} value={key} style={{width: '100%', 
                        // border: getAnswerOptionBorderStyle(ele, key),
                        borderRadius: '5px', padding: '10px'}}>
                            <Input defaultValue={ele} style={{width: '100%'}} onChange={(v)=>handleTextChange(v, key)}/>
                        </Radio>)}
                {/* </Space> */}
            </Radio.Group>
            <ImageDisplay imgList={url} isEdit={true} document_id={document_id} question_id={question_id} page={page}/>
        </>
    );
}